// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { Link } from 'react-router-dom';
import './Alert.scss';
import { Subscriber } from '../../../api/Subscriber';
import { CSSTransitionGroup  } from 'react-transition-group';

@inject('userStore')
@observer class Alert extends Component<any, any> {

	subscriber = new Subscriber();

	@observable match?: any = null;

	currentTimeout: any;

	constructor(props: any) {
		super(props);

		this.matchCreateEvent = this.matchCreateEvent.bind(this);
		this.removeAlert = this.removeAlert.bind(this);

		this.subscriber.addTopic(
			'/me/matches/' + this.props.userStore.user.id, 
			'create_match', 
			this.matchCreateEvent);
	}

	componentDidMount() {
		this.subscriber.subscribe();
	}

	componentWillUnmount() {
		this.subscriber.unsubscribe();
	}

	matchCreateEvent(response: any) {
		if (response['@match'].participants[1].id === this.props.userStore.user.id) {
			this.match = response['@match'];
			this.currentTimeout = setTimeout(() => {
				this.match = null;
			}, 10000);
		}
	} 

	removeAlert(e: any) {
		this.match = null;
		clearTimeout(this.currentTimeout);
	}

	render() {
		return (
			<CSSTransitionGroup  
				transitionName="animate-match-alert"
				transitionEnterTimeout={400}
				transitionLeaveTimeout={600}>
				{this.match ?
					<div className="match-alert">			
						<div className="match-teaser">you got matched from {this.match.participants[0].id === this.props.userStore.user.id ? this.match.participants[1].username : this.match.participants[0].username}</div>
						<Link className="view-match" onClick={this.removeAlert} to={'/match/' + this.match.id}>view match</Link>
					</div>
				: null}
			</CSSTransitionGroup>

		)
	}
}

export default Alert;

